import React from 'react';
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { GLYPHS, GRID, STROKE_WIDTH, type GlyphName } from './glyphs';

export type RuttiaIconProps = Omit<SvgIconProps, 'children'> & { name: GlyphName };

/**
 * Ícono propio de Ruttia (ruttia-platform/design/iconos). Trazo de 1,75 sin relleno; el color sale
 * del tema (`currentColor`), así funciona en claro, oscuro y con la marca de cada empresa.
 * Mismos props que los íconos de Material UI (`fontSize`, `color`, `sx`…).
 */
export const RuttiaIcon: React.FC<RuttiaIconProps> = ({ name, sx, ...rest }) => (
  <SvgIcon
    viewBox={`0 0 ${GRID} ${GRID}`}
    {...rest}
    sx={[
      { fill: 'none', stroke: 'currentColor', strokeWidth: STROKE_WIDTH, strokeLinecap: 'round', strokeLinejoin: 'round' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {(GLYPHS[name] as readonly (readonly (string | number)[])[]).map((shape, i) => {
      const [kind, ...a] = shape as [string, ...number[]];
      if (kind === 'circle') return <circle key={i} cx={a[0]} cy={a[1]} r={a[2]} />;
      if (kind === 'rect') return <rect key={i} x={a[0]} y={a[1]} width={a[2]} height={a[3]} rx={a[4] ?? 0} />;
      return <path key={i} d={String(shape[1])} />;
    })}
  </SvgIcon>
);

export const hasGlyph = (name: string): name is GlyphName => Object.prototype.hasOwnProperty.call(GLYPHS, name);
